import { api } from '../api';

const toArray = (body) =>
  body?.data?.content
  ?? body?.content
  ?? (Array.isArray(body?.data) ? body.data : null)
  ?? (Array.isArray(body) ? body : []);

export default {
  list:        (params)   => api.get('/v1/bookings', { params }).then(r => toArray(r.data)),
  today:       (params)   => api.get('/v1/bookings', { params: { date: 'today', ...(params || {}) } }).then(r => toArray(r.data)),
  get:         (id)       => api.get(`/v1/bookings/${id}`).then(r => r.data),
  cancel:      (id, body) => api.post(`/v1/bookings/${id}/cancel`, body || {}).then(r => r.data),
  testDriveSlots: (params) => api.get('/v1/bookings/test-drive/slots', { params }).then(r => r.data),
  serviceSlots:   (params) => api.get('/v1/bookings/service/slots', { params }).then(r => r.data),
  journey:        (bookingId) => api.get(`/v1/service-journey/events/${bookingId}`).then(r => r.data?.data ?? r.data),
};
